import type { Contact } from "../types";
import { todayIsoDate } from "../misc/formatDate";

export const validateNoteRequired = (value: string | null | undefined) => {
  const hasText = typeof value === "string" && value.trim().length > 0;
  return hasText ? undefined : "resources.notes.validation.text_required";
};

/** Option renderer for contact autocompletes in note forms. */
export const contactOptionText = (contact: Contact) =>
  [contact.first_name, contact.last_name].filter(Boolean).join(" ");

/** Local `YYYY-MM-DD` day of an ISO datetime, like the date input displays it. */
const localDay = (value?: string | null): string => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

/**
 * Turns the value of the date input (`YYYY-MM-DD`) into the ISO datetime the
 * backend stores. Today keeps the current time so notes added on the same day
 * stay in order; other days are stored at local noon so the date never shifts.
 * When editing a note whose day did not change, the original datetime is kept.
 */
export const toNoteDate = (
  value?: string | null,
  previous?: string | null,
): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? "");
  if (!match) return new Date().toISOString();
  const day = match[0];
  if (previous && localDay(previous) === day) return previous;
  if (day === todayIsoDate()) return new Date().toISOString();
  return new Date(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3]),
    12,
  ).toISOString();
};
